import styles from './offer-message.module.css'
import type { Offer } from '@/utils/offers'

export default function OfferMessage({
	message,
	offer,
	compact = false
}: {
	message?: string | null
	offer?: Pick<Offer, 'scope' | 'trait_type' | 'trait_value'>
	compact?: boolean
}) {
	if (!message?.trim()) return null
	return (
		<div className={styles.message} data-scope={offer?.scope ?? 'item'}>
			<span className={styles.heading}>
				Buyer’s message <span className={styles.badge}>Public</span>
			</span>
			{offer?.scope === 'collection' && (
				<span className={styles.audience}>Any item in this collection</span>
			)}
			{offer?.scope === 'trait' && (
				<span className={styles.audience}>
					For {offer.trait_type}: {offer.trait_value}
				</span>
			)}
			<p className={compact ? styles.compact : undefined} dir="auto">
				{message}
			</p>
		</div>
	)
}
